/**
 * Brain Fog Field Guide - Interactive Features
 * Scoped to .brainfog-page wrapper for Shopify integration
 *
 * Features:
 *   - Scroll progress bar
 *   - Sticky navigation with active link highlighting
 *   - Back-to-top button
 *   - Scroll-triggered animations (IntersectionObserver)
 *   - Animated stat counters
 *   - Self-assessment interactive quiz
 *   - Tier filtering for strategy cards
 *   - Smart search / "Ask the Guide" with synonym expansion
 *   - Clickable decision tree with gold-pulse highlight
 *   - Hamburger mobile menu
 *   - Smooth-scroll anchor links
 *   - FAQ accordion
 */

document.addEventListener('DOMContentLoaded', function() {

  // ‚îÄ‚îÄ SCOPE GUARD ‚îÄ‚îÄ
  // All DOM queries are scoped to the .brainfog-page wrapper.
  // If the wrapper is not present on this page, bail out immediately.
  var PAGE = document.querySelector('.brainfog-page');
  if (!PAGE) return;

  // ‚îÄ‚îÄ CSS LOADER ‚îÄ‚îÄ
  // Shopify sections render inside <body> divs where <link> and <style> tags
  // get stripped by the browser. Load CSS and fonts via JS instead.
  (function loadBrainfogCSS() {
    // Load Google Fonts
    if (!document.querySelector('link[href*="DM+Serif"]')) {
      var fonts = document.createElement('link');
      fonts.rel = 'stylesheet';
      fonts.href = 'https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=JetBrains+Mono:wght@400;600&display=swap';
      document.head.appendChild(fonts);
    }
    // Load brainfog.css
    if (!document.querySelector('link[href*="brainfog.css"]')) {
      var cssEl = PAGE.querySelector('style');
      if (cssEl && cssEl.textContent.indexOf('brainfog.css') !== -1) {
        // Extract the URL from the @import if present
        var match = cssEl.textContent.match(/url\("([^"]*brainfog\.css[^"]*)"\)/);
        if (match) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = match[1];
          document.head.appendChild(link);
        }
      }
      // Fallback: try to find the asset URL from any script src on this page
      if (!document.querySelector('link[href*="brainfog.css"]')) {
        var scripts = document.querySelectorAll('script[src*="brainfog.js"]');
        if (scripts.length) {
          var jsUrl = scripts[0].src;
          var cssUrl = jsUrl.replace('brainfog.js', 'brainfog.css').replace(/\?.*/, '');
          var link2 = document.createElement('link');
          link2.rel = 'stylesheet';
          link2.href = cssUrl;
          document.head.appendChild(link2);
        }
      }
    }
  })();

  // Helper: query within the page wrapper (single element)
  function $page(selector) {
    return PAGE.querySelector(selector);
  }
  // Helper: queryAll within the page wrapper (NodeList)
  function $$page(selector) {
    return PAGE.querySelectorAll(selector);
  }


  // ‚îÄ‚îÄ SCROLL PROGRESS BAR ‚îÄ‚îÄ
  var progressBar = document.getElementById('scroll-progress');
  function updateProgress() {
    if (!progressBar) return;
    var scrollTop = window.pageYOffset;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    progressBar.style.width = progress + '%';
  }


  // ‚îÄ‚îÄ STICKY NAV ‚îÄ‚îÄ
  var nav = document.getElementById('sticky-nav');
  var lastScroll = 0;
  function updateNav() {
    if (!nav) return;
    var scrollTop = window.pageYOffset;
    if (scrollTop > 600) {
      nav.classList.add('visible');
    } else {
      nav.classList.remove('visible');
    }
    lastScroll = scrollTop;
  }


  // ‚îÄ‚îÄ BACK TO TOP ‚îÄ‚îÄ
  var backToTop = document.getElementById('back-to-top');
  function updateBackToTop() {
    if (!backToTop) return;
    if (window.pageYOffset > 800) {
      backToTop.classList.add('visible');
    } else {
      backToTop.classList.remove('visible');
    }
  }
  if (backToTop) {
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }


  // ‚îÄ‚îÄ COMBINED SCROLL HANDLER ‚îÄ‚îÄ
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        updateProgress();
        updateNav();
        updateBackToTop();
        ticking = false;
      });
      ticking = true;
    }
  });


  // ‚îÄ‚îÄ HAMBURGER MENU ‚îÄ‚îÄ
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('open');
      });
    });
  }


  // ‚îÄ‚îÄ SCROLL ANIMATIONS (IntersectionObserver) ‚îÄ‚îÄ
  var animElements = $$page('.anim, .anim-left, .anim-right, .anim-scale');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vis');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });
    animElements.forEach(function(el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show everything immediately
    animElements.forEach(function(el) {
      el.classList.add('vis');
    });
  }


  // ‚îÄ‚îÄ ANIMATED STAT COUNTERS ‚îÄ‚îÄ
  var statNums = $$page('.stat-num[data-count]');
  if (statNums.length > 0) {
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    statNums.forEach(function(el) {
      counterObserver.observe(el);
    });
  }

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1500;
    var startTime = performance.now();

    function update(currentTime) {
      var elapsed = currentTime - startTime;
      var progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);
      el.textContent = current + suffix;
      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }
    requestAnimationFrame(update);
  }


  // ‚îÄ‚îÄ SELF-ASSESSMENT INTERACTIVE ‚îÄ‚îÄ
  var assessForm = document.getElementById('assess-form');
  var assessResult = document.getElementById('assess-result');
  var assessScore = document.getElementById('assess-score');
  var assessInterp = document.getElementById('assess-interp');
  var scores = new Array(13).fill(-1);

  if (assessForm) {
    assessForm.addEventListener('click', function(e) {
      var btn = e.target.closest('.assess-btn');
      if (!btn) return;

      var question = btn.closest('.assess-q');
      var qIndex = parseInt(question.getAttribute('data-q'));
      var value = parseInt(btn.getAttribute('data-val'));

      // Deselect siblings
      question.querySelectorAll('.assess-btn').forEach(function(b) {
        b.classList.remove('selected');
      });
      btn.classList.add('selected');

      scores[qIndex] = value;

      // Check if all answered
      var allAnswered = scores.every(function(s) { return s >= 0; });
      if (allAnswered) {
        var total = scores.reduce(function(a, b) { return a + b; }, 0);
        assessScore.textContent = total;
        assessResult.style.display = 'block';
        assessResult.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Highlight correct scoring row
        var range;
        if (total < 10) range = 'low';
        else if (total < 20) range = 'light';
        else if (total < 30) range = 'moderate';
        else if (total < 40) range = 'severe';
        else range = 'critical';

        $$page('.scoring-row').forEach(function(row) {
          row.classList.remove('active');
          if (row.getAttribute('data-range') === range) {
            row.classList.add('active');
          }
        });

        var interpText;
        if (total < 10) interpText = 'Your score suggests cognitive fluctuation within normal range. Monitor and follow up if symptoms worsen.';
        else if (total < 20) interpText = 'Your score suggests light cognitive impairment. Start with Parts I\u2013III (Sleep, Diet, Movement) and investigate thyroid function.';
        else if (total < 30) interpText = 'Your score suggests light to moderate impairment. A systematic approach with blood work is recommended. Work through Parts I\u2013VI.';
        else if (total < 40) interpText = 'Your score suggests moderate to severe impairment. Consult a specialist in addition to self-investigation. Prioritize Rule-Outs (Part IV).';
        else interpText = 'Your score suggests severe cognitive impairment. Please seek medical attention promptly to eliminate organic causes.';

        assessInterp.textContent = interpText;
      }
    });
  }


  // ‚îÄ‚îÄ TIER FILTERING ‚îÄ‚îÄ
  PAGE.addEventListener('click', function(e) {
    var btn = e.target.closest('.tier-filter-btn');
    if (!btn) return;

    var container = btn.closest('section') || btn.closest('.container');
    if (!container) return;

    // Update active state within this filter group
    var filterGroup = btn.closest('.tier-filter');
    if (filterGroup) {
      filterGroup.querySelectorAll('.tier-filter-btn').forEach(function(b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
    }

    var tier = btn.getAttribute('data-tier');
    var cards = container.querySelectorAll('.strategy-card');

    cards.forEach(function(card) {
      if (tier === 'all') {
        card.classList.remove('hidden');
      } else {
        if (card.getAttribute('data-tier') === tier) {
          card.classList.remove('hidden');
        } else {
          card.classList.add('hidden');
        }
      }
    });
  });


  // ‚îÄ‚îÄ ACTIVE NAV LINK HIGHLIGHTING ‚îÄ‚îÄ
  var navLinks = $$page('.nav-links a');
  var sections = [];
  navLinks.forEach(function(link) {
    var href = link.getAttribute('href');
    if (href && href.startsWith('#')) {
      var target = document.getElementById(href.substring(1));
      if (target) {
        sections.push({ el: target, link: link });
      }
    }
  });

  function updateActiveNav() {
    var scrollPos = window.pageYOffset + 100;
    var current = null;
    for (var i = sections.length - 1; i >= 0; i--) {
      if (scrollPos >= sections[i].el.offsetTop) {
        current = sections[i].link;
        break;
      }
    }
    navLinks.forEach(function(link) { link.classList.remove('active'); });
    if (current) current.classList.add('active');
  }

  var navTicking = false;
  window.addEventListener('scroll', function() {
    if (!navTicking) {
      requestAnimationFrame(function() {
        updateActiveNav();
        navTicking = false;
      });
      navTicking = true;
    }
  });


  // ‚îÄ‚îÄ SMOOTH SCROLL FOR ANCHOR LINKS ‚îÄ‚îÄ
  PAGE.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var targetId = link.getAttribute('href').substring(1);
    var target = document.getElementById(targetId);
    if (target) {
      e.preventDefault();
      var offset = (nav && nav.classList.contains('visible')) ? 64 : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });


  // ‚îÄ‚îÄ ASK THE GUIDE / SMART SEARCH ‚îÄ‚îÄ
  var searchInput = document.getElementById('search-input');
  var searchClear = document.getElementById('search-clear');
  var searchSummary = document.getElementById('search-summary');
  var searchSummaryText = document.getElementById('search-summary-text');
  var searchSummaryClear = document.getElementById('search-summary-clear');
  var askResults = document.getElementById('ask-results');
  var askResultsText = document.getElementById('ask-results-text');
  var askResultsClear = document.getElementById('ask-results-clear');
  var navSearchBtn = document.getElementById('nav-search-btn');

  // Synonym map: common user language mapped to clinical terms in the guide
  var synonyms = {
    'tired': ['fatigue','exhaustion','energy','lethargy','malaise'],
    'fatigue': ['tired','exhaustion','energy','lethargy'],
    'focus': ['concentration','attention','cognitive','ADHD','executive function'],
    'concentrate': ['focus','attention','cognitive','concentration'],
    'dizzy': ['lightheaded','vertigo','POTS','orthostatic','vestibular'],
    'lightheaded': ['dizzy','vertigo','POTS','orthostatic'],
    'gut': ['digestive','microbiome','IBS','SIBO','celiac','intestinal'],
    'stomach': ['digestive','gut','microbiome','IBS','SIBO','nausea'],
    'anxiety': ['stress','cortisol','HPA','anxious','panic','worry'],
    'stress': ['anxiety','cortisol','HPA','burnout','adrenal'],
    'sleep': ['insomnia','circadian','melatonin','glymphatic','rest','UARS'],
    'insomnia': ['sleep','circadian','melatonin','rest'],
    'memory': ['recall','forgetful','hippocampus','amnesia','remember'],
    'headache': ['migraine','head pain','tension','cranial'],
    'inflammation': ['cytokine','inflammatory','CRP','immune','neuroinflammation'],
    'hormone': ['estrogen','progesterone','testosterone','thyroid','cortisol','perimenopause','HRT'],
    'covid': ['long COVID','post-viral','SARS','coronavirus','post-COVID'],
    'supplement': ['vitamin','mineral','nutrient','magnesium','omega','B12','iron','zinc'],
    'exercise': ['movement','aerobic','BDNF','walking','workout','physical activity'],
    'depression': ['mood','serotonin','SSRI','antidepressant','depressed'],
    'food': ['diet','nutrition','blood sugar','glucose','meal','eating','protein'],
    'medication': ['drug','prescription','side effect','statin','beta-blocker','PPI'],
    'thyroid': ['TSH','T3','T4','hashimoto','hypothyroid','levothyroxine'],
    'pain': ['headache','migraine','ache','inflammation','fibromyalgia'],
    'weight': ['metabolism','obesity','BMI','insulin','leptin'],
    // Extended synonym map
    'diet': ['food','nutrition','meal','recipe','elimination','trigger','anti-inflammatory'],
    'recipe': ['meal','food','cook','kitchen','ingredient'],
    'profile': ['sugar crasher','gluten reactor','histamine','gut-wrecked','inflamer','processed'],
    'clarity': ['fog factor','disconnection','depletion','dysregulation','toxicity','reset'],
    'reset': ['clarity','7-day','seven day','protocol','practice'],
    'trigger': ['food','reaction','sensitivity','intolerance','elimination'],
    'histamine': ['DAO','mast cell','aged cheese','wine','fermented'],
    'gluten': ['celiac','zonulin','wheat','bread','pasta'],
    'mold': ['CIRS','mycotoxin','biotoxin','water damage'],
    'perimenopause': ['menopause','estrogen','progesterone','hot flash','hormone replacement']
  };

  // Build search index from all strategy cards
  var searchIndex = [];
  var allCards = $$page('.strategy-card');
  allCards.forEach(function(card) {
    var name = (card.querySelector('.strat-name') || {}).textContent || '';
    var desc = (card.querySelector('.strat-desc') || {}).textContent || '';
    var protocol = (card.querySelector('.strat-protocol') || {}).textContent || '';
    var caution = (card.querySelector('.strat-caution') || {}).textContent || '';
    var partSection = card.closest('section');
    var partTitle = '';
    if (partSection) {
      var pt = partSection.querySelector('.part-title');
      if (pt) partTitle = pt.textContent;
    }
    searchIndex.push({
      el: card,
      text: (name + ' ' + desc + ' ' + protocol + ' ' + caution + ' ' + partTitle).toLowerCase(),
      nameEl: card.querySelector('.strat-name'),
      descEl: card.querySelector('.strat-desc'),
      protocolEl: card.querySelector('.strat-protocol')
    });
  });

  // Store original HTML for unhighlighting
  searchIndex.forEach(function(item) {
    if (item.nameEl) item.origName = item.nameEl.innerHTML;
    if (item.descEl) item.origDesc = item.descEl.innerHTML;
    if (item.protocolEl) item.origProtocol = item.protocolEl.innerHTML;
  });

  var searchActive = false;

  // Nav "Ask" button scrolls to the search bar
  if (navSearchBtn) {
    navSearchBtn.addEventListener('click', function() {
      var askSection = document.getElementById('ask-the-guide');
      if (askSection) {
        var offset = 20;
        var top = askSection.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        setTimeout(function() { if (searchInput) searchInput.focus(); }, 500);
      }
    });
  }

  // Quick-search chips
  PAGE.addEventListener('click', function(e) {
    var chip = e.target.closest('.ask-chip');
    if (!chip) return;
    var query = chip.getAttribute('data-query');
    if (!query || !searchInput) return;
    // Update active chip
    $$page('.ask-chip').forEach(function(c) { c.classList.remove('active'); });
    chip.classList.add('active');
    // Fill input and run search
    searchInput.value = query;
    if (searchClear) searchClear.classList.add('show');
    runSearch(query);
  });

  // Debounced search on input
  var searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (searchClear) searchClear.classList.toggle('show', q.length > 0);
      // Clear active chip if user is typing something different
      $$page('.ask-chip').forEach(function(c) { c.classList.remove('active'); });
      searchTimer = setTimeout(function() { runSearch(q); }, 300);
    });

    // Enter key triggers search immediately
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        clearTimeout(searchTimer);
        runSearch(searchInput.value.trim());
      }
      if (e.key === 'Escape') {
        clearSearch();
        searchInput.blur();
      }
    });
  }

  if (searchClear) searchClear.addEventListener('click', clearSearch);
  if (searchSummaryClear) searchSummaryClear.addEventListener('click', clearSearch);
  if (askResultsClear) askResultsClear.addEventListener('click', clearSearch);

  function expandQuery(query) {
    var words = query.toLowerCase().split(/\s+/);
    var expanded = words.slice();
    words.forEach(function(w) {
      if (synonyms[w]) {
        synonyms[w].forEach(function(syn) {
          if (expanded.indexOf(syn.toLowerCase()) === -1) {
            expanded.push(syn.toLowerCase());
          }
        });
      }
    });
    return expanded;
  }

  function runSearch(query) {
    // Restore original content first
    searchIndex.forEach(function(item) {
      if (item.nameEl && item.origName) item.nameEl.innerHTML = item.origName;
      if (item.descEl && item.origDesc) item.descEl.innerHTML = item.origDesc;
      if (item.protocolEl && item.origProtocol) item.protocolEl.innerHTML = item.origProtocol;
    });

    if (!query) {
      clearSearch();
      return;
    }

    searchActive = true;
    var terms = expandQuery(query);
    var matchCount = 0;
    var firstMatch = null;

    searchIndex.forEach(function(item) {
      var matched = terms.some(function(term) {
        return item.text.indexOf(term) !== -1;
      });
      if (matched) {
        item.el.classList.remove('search-hidden');
        matchCount++;
        if (!firstMatch) firstMatch = item.el;
        highlightTerms(item, query.toLowerCase().split(/\s+/));
      } else {
        item.el.classList.add('search-hidden');
      }
    });

    // Show inline results panel
    if (askResults && askResultsText) {
      askResultsText.textContent = matchCount + ' strateg' + (matchCount === 1 ? 'y matches' : 'ies match') + ' \u201c' + query + '\u201d \u2014 scroll down to browse';
      askResults.style.display = 'block';
    }

    // Show sticky summary bar too (visible when scrolled away from ask section)
    if (searchSummaryText && searchSummary) {
      searchSummaryText.textContent = matchCount + ' strateg' + (matchCount === 1 ? 'y' : 'ies') + ' matching \u201c' + query + '\u201d';
      searchSummary.classList.add('show');
    }

    // Scroll to first match
    if (firstMatch) {
      var navOffset = (nav && nav.classList.contains('visible')) ? 120 : 60;
      var scrollTop = firstMatch.getBoundingClientRect().top + window.pageYOffset - navOffset;
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  }

  function highlightTerms(item, words) {
    words.forEach(function(word) {
      if (word.length < 2) return;
      var regex = new RegExp('(' + word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      if (item.nameEl) item.nameEl.innerHTML = item.nameEl.innerHTML.replace(regex, '<mark>$1</mark>');
      if (item.descEl) item.descEl.innerHTML = item.descEl.innerHTML.replace(regex, '<mark>$1</mark>');
      if (item.protocolEl) item.protocolEl.innerHTML = item.protocolEl.innerHTML.replace(regex, '<mark>$1</mark>');
    });
  }

  function clearSearch() {
    if (searchInput) searchInput.value = '';
    if (searchClear) searchClear.classList.remove('show');
    if (searchSummary) searchSummary.classList.remove('show');
    if (askResults) askResults.style.display = 'none';
    $$page('.ask-chip').forEach(function(c) { c.classList.remove('active'); });
    searchActive = false;
    searchIndex.forEach(function(item) {
      item.el.classList.remove('search-hidden');
      if (item.nameEl && item.origName) item.nameEl.innerHTML = item.origName;
      if (item.descEl && item.origDesc) item.descEl.innerHTML = item.origDesc;
      if (item.protocolEl && item.origProtocol) item.protocolEl.innerHTML = item.origProtocol;
    });
  }


  // ‚îÄ‚îÄ CLICKABLE DECISION TREE ‚îÄ‚îÄ
  PAGE.addEventListener('click', function(e) {
    var row = e.target.closest('.flow-row-linked');
    if (!row) return;
    var targetId = row.getAttribute('data-target');
    if (!targetId) return;
    var target = document.getElementById(targetId);
    if (!target) return;

    var navOffset = (nav && nav.classList.contains('visible')) ? 80 : 20;
    var scrollTop = target.getBoundingClientRect().top + window.pageYOffset - navOffset;
    window.scrollTo({ top: scrollTop, behavior: 'smooth' });

    // Gold pulse highlight
    target.classList.remove('gold-pulse');
    void target.offsetWidth; // force reflow to restart animation
    target.classList.add('gold-pulse');
    setTimeout(function() { target.classList.remove('gold-pulse'); }, 1600);
  });


  // ‚îÄ‚îÄ FAQ ACCORDION ‚îÄ‚îÄ
  $$page('.faq-item h3').forEach(function(h3) {
    h3.addEventListener('click', function() {
      var item = this.parentElement;
      var wasOpen = item.classList.contains('open');
      $$page('.faq-item').forEach(function(faq) {
        faq.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });

});
